(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector-clinic-name', {
            parent: 'entity',
            url: '/sector-clinic-name?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorClinicName.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-names.html',
                    controller: 'SectorClinicNameController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorClinicName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-clinic-name-detail', {
            parent: 'entity',
            url: '/sector-clinic-name/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorClinicName.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-name-detail.html',
                    controller: 'SectorClinicNameDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorClinicName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectorClinicName', function($stateParams, SectorClinicName) {
                    return SectorClinicName.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector-clinic-name.new', {
            parent: 'sector-clinic-name',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-name-dialog.html',
                    controller: 'SectorClinicNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector-clinic-name', null, { reload: true });
                }, function() {
                    $state.go('sector-clinic-name');
                });
            }]
        })
        .state('sector-clinic-name.edit', {
            parent: 'sector-clinic-name',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-name-dialog.html',
                    controller: 'SectorClinicNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SectorClinicName', function(SectorClinicName) {
                            return SectorClinicName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-clinic-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector-clinic-name.delete', {
            parent: 'sector-clinic-name',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-name-delete-dialog.html',
                    controller: 'SectorClinicNameDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SectorClinicName', function(SectorClinicName) {
                            return SectorClinicName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-clinic-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
